<template>
    <el-dialog custom-class="dialogForm" class="measDialog" :visible.sync="visible" :before-close="handleClose" :close-on-click-modal="false" width="80%" :title="title">
        <el-scrollbar class="dialogContentScroll">
            <el-form :model="form" ref="form" :rules="rules">
                <div class="formItemBox mb-15">
                    <el-form-item label="班级名称" prop="">
                        <el-input :disabled="true" v-model="initData.className" maxlength="20" show-word-limit placeholder="请输入" clearable></el-input>
                    </el-form-item>
                </div>
                <div class="formItemBox mb-15">
                    <el-form-item label="课程名称" prop="">
                        <el-input :disabled="true" v-model="initData.classCourseName" maxlength="20" show-word-limit placeholder="请输入" clearable></el-input>
                    </el-form-item>
                </div>
                <div class="formItemBox mb-15">
                    <el-form-item label="顺延课时名称" prop="">
                        <el-input :disabled="true" v-model="initData.syClassCourseName" maxlength="20" show-word-limit placeholder="请输入" clearable></el-input>
                    </el-form-item>
                </div>
                <div class="formItemBox mb-15">
                    <el-form-item label="顺延课时日期" prop="perioddate">
                        <el-date-picker
                            value-format="yyyy-MM-dd"
                            v-model="form.perioddate"
                            type="date"
                            placeholder="选择日期">
                        </el-date-picker>
                    </el-form-item>
                </div>
                <div class="formItemBox mb-15">
                    <el-form-item label="顺延周期" prop="delaydays">
                        <el-input v-model="form.delaydays"  show-word-limit placeholder="请输入" clearable></el-input>
                    </el-form-item>
                </div>
            </el-form>
        </el-scrollbar>
        <div slot="footer" style="text-align:right">
            <el-button @click="visible = false">取 消</el-button>
            <el-button type="primary" :loading="isLoading" @click="saveClass('form')">确定</el-button>
        </div>
    </el-dialog>
</template>
<script>
import {delayCourseperiod} from '@/api/measApi/teachManagement.js'
export default {
    data(){
        return {
            visible: false,
            title: '顺延课时',
            isLoading: false,
            initData: {
                className: '',
                classCourseName: '',
                syClassCourseName: ''

            },
            form: {
                code: '',
                delaydays: '',
                endtime: '',
                perioddate: '',
                starttime: ''
            },
            rules: {
                perioddate: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                delaydays: [
                    { required: true, message: '请输入', trigger: 'change' }
                ]
            }
        }
    },
    methods: {
        init(row){
            this.initData.className = row.classname
            this.initData.classCourseName = row.classcoursename
            this.initData.syClassCourseName = row.periodname
            this.form.code = row.code
            this.visible = true
        },
        handleClose(){
            this.visible = false
        },
        saveClass(formName){
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.isLoading = true
                    this.$confirm('顺延排课之后会将后续的课时按顺延规则重新修改，继续吗？', '顺延课时', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    }).then(() => {
                        this.delayCourseperiod(formName)
                    }).catch(() => {
                        this.isLoading = false
                    })
                } else {
                    this.isLoading = false
                    return false;
                }
            });
        },
        delayCourseperiod(formName){
            delayCourseperiod(this.form).then(res => {
                this.isLoading = false
                if(res.code === '000'){
                    this.visible = false
                    this.$parent.init()
                    this.$refs[formName].resetFields()
                    this.$message.success(res.msg)
                }
            })
        }
    }
}
</script>